import { createModerationClient } from '@orbit-mind/api-client';

export function shareReaderId(): Promise<string> {
  const key = 'orbit-mind.share-reader';
  const existing = localStorage.getItem(key);
  if (
    existing !== null &&
    /^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i.test(existing)
  )
    return Promise.resolve(existing);
  const id = crypto.randomUUID();
  localStorage.setItem(key, id);
  return Promise.resolve(id);
}
export const moderationClient = createModerationClient({
  fetch: (input, init) => globalThis.fetch(input, init),
  readerId: shareReaderId,
});
